import React from 'react'
import PropTypes from 'prop-types'
import styled from 'react-emotion'
import { themeGet as th } from 'styled-system'
import { Tooltip } from 'shared/ui'

import theme from './theme'
import Icon from './Icon'

const IconLink = ({ className, onClick, tooltip, text, ...rest }) => {
  return (
    <a onClick={onClick} className={className}>
      {!tooltip && <Icon {...rest} />}
      {tooltip && (
        <Tooltip tooltip={tooltip}>
          {' '}
          <Icon {...rest} />{' '}
        </Tooltip>
      )}
      {text}
    </a>
  )
}

IconLink.propTypes = {
  name: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  text: PropTypes.string,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
}

IconLink.defaultProps = {
  text: undefined,
  theme,
}

export default styled(IconLink)`
  align-items: center;
  color: ${th('colors.blue')};
  cursor: pointer;
  display: flex;
  flex: 1;

  .Icon {
    padding-right: ${th('space.2')}px;
  }

  &:hover {
    color: ${th('colors.blueHover')};
  }
`
